import { purple } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 * Colours named by how they are used, for the two cases the palette has no intent for.
 *
 * Everything else that used to live here now reads a palette slot at the call site, so it follows
 * the active colour scheme: the placeholder colour is `text.disabled` and the normal font colour
 * is `text.primary`.
 */
export const colorConst = {
  /** Background color for the tag and badge to indicate that something is new */
  newFeatureIndicator: PALETTE_VARS.secondary.main,
  /** Font/background color for dev features which aren't visible to regular users */
  devFeature: purple[500]
};